import { useState, useRef } from "react";
import { Image as ImageIcon, Upload, X, Loader2 } from "lucide-react";
import { toast } from "react-toastify";
import API from "../api/axiosConfig";

export default function CampaignImageField({ value, onChange, label = "Imagen (opcional)" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const doUpload = async (file) => {
    if (!file || !file.type.startsWith("image/")) {
      toast.error("Solo se permiten imágenes");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("image", file);
      const r = await API.post("/upload/image?folder=marketing", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const url = r.data?.data?.url;
      if (url) onChange(url);
      else throw new Error("No URL returned");
    } catch {
      toast.error("Error al subir la imagen");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-xs font-semibold text-gray-500 flex items-center gap-1">
        <ImageIcon size={11} /> {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://... (o subí una imagen)"
          className="flex-1 border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-supernova-300"
        />
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => { const f = e.target.files?.[0]; if (f) doUpload(f); e.target.value = ""; }}
        />
        <button
          type="button"
          onClick={() => !uploading && inputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs font-semibold rounded-lg transition disabled:opacity-50 whitespace-nowrap"
        >
          {uploading ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />} Subir
        </button>
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition"
            title="Quitar imagen"
          >
            <X size={13} />
          </button>
        )}
      </div>
      {value && (
        <img src={value} alt="preview" className="max-h-32 rounded-lg border border-gray-100 object-cover" />
      )}
    </div>
  );
}
